export function FulfillmentIcon({ ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" {...props}>
      <g id="Group_24483" data-name="Group 24483" transform="translate(-865 -172)">
        <g
          id="Rectangle_10299"
          data-name="Rectangle 10299"
          transform="translate(865 172)"
          fill="#fff"
          stroke="currentColor"
          strokeWidth="1"
          opacity="0"
        >
          <rect width="24" height="24" stroke="none" />
          <rect x="0.5" y="0.5" width="23" height="23" fill="none" />
        </g>
        <g id="Group_16825" data-name="Group 16825" transform="translate(-7 12.106)">
          <path
            id="Path_28458"
            data-name="Path 28458"
            d="M628.5,3699.225l-8.5,4.669m0,0-8.5-4.669m8.5,4.669v9.4m9-5.382v-8.033a2.253,2.253,0,0,0-.05-.663,1.063,1.063,0,0,0-.215-.356,2.262,2.262,0,0,0-.558-.366l-7.4-4.066a2.519,2.519,0,0,0-.576-.267,1.369,1.369,0,0,0-.4,0,2.518,2.518,0,0,0-.576.267l-7.4,4.066a2.26,2.26,0,0,0-.558.366,1.064,1.064,0,0,0-.215.356,2.258,2.258,0,0,0-.05.663v8.033a2.254,2.254,0,0,0,.05.663,1.069,1.069,0,0,0,.215.356,2.255,2.255,0,0,0,.558.366l7.4,4.066a2.492,2.492,0,0,0,.576.267,1.353,1.353,0,0,0,.4,0,2.494,2.494,0,0,0,.576-.267l7.4-4.066a2.257,2.257,0,0,0,.558-.366,1.067,1.067,0,0,0,.215-.356A2.248,2.248,0,0,0,629,3707.911Z"
            transform="translate(264 -3532)"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.6"
          />
          <path
            id="Path_28459"
            data-name="Path 28459"
            d="M624.5,3701.5l-9-5"
            transform="translate(264 -3532.053)"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.6"
          />
        </g>
      </g>
    </svg>
  );
}
